import { createSlice } from "@reduxjs/toolkit";
import {     reKyc_KRA_DataThunk } from "./thunk";

export const initialState = {
  reKyc_KRA_FetchData: [],
  reKyc_KRA_FetchError: '', // for error message
  reKyc_KRA_FetchLoading: false,
  
  
};

const Re_Kyc_KRA_Data = createSlice({
  name: "Re_Kyc_KRA_Data",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_KRA_DataThunk.pending, (state) => {
      state.reKyc_KRA_FetchLoading = true ;
      state.reKyc_KRA_FetchData= [];
      state.reKyc_KRA_FetchError='';

  });
    builder.addCase(reKyc_KRA_DataThunk.fulfilled, (state, action) => {
        state.reKyc_KRA_FetchData = action.payload.data;
        state.reKyc_KRA_FetchLoading = false ;
    });
    builder.addCase(reKyc_KRA_DataThunk.rejected, (state, action) => {
      state.reKyc_KRA_FetchError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_KRA_FetchLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_KRA_Data.actions

export default Re_Kyc_KRA_Data.reducer;